import { render, staticRenderFns } from "./ModerationPage.vue?vue&type=template&id=7a8cc8f3&scoped=true&"
import script from "./ModerationPage.vue?vue&type=script&lang=ts&"
export * from "./ModerationPage.vue?vue&type=script&lang=ts&"
import style0 from "./ModerationPage.vue?vue&type=style&index=0&id=7a8cc8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cc8f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsSlider})
